/**
 * Gain Smoothing
 *
 * Functions for smoothing audio gain changes to prevent clicks/pops
 */

/**
 * Apply smooth gain transition using Web Audio API's setTargetAtTime
 *
 * @param gainNode The GainNode to modify
 * @param targetGain Target gain value (0-1)
 * @param audioContext AudioContext for timing
 * @param timeConstant Time constant for transition (default: 0.1 = ~300ms to settle)
 */
export function applyGainSmooth(
  gainNode: GainNode,
  targetGain: number,
  audioContext: AudioContext,
  timeConstant: number = 0.1
): void {
  try {
    gainNode.gain.setTargetAtTime(
      targetGain,
      audioContext.currentTime,
      timeConstant
    );
  } catch (err) {
    // Fallback: set value directly
    gainNode.gain.value = targetGain;
  }
}

/**
 * Apply smooth stereo pan transition
 *
 * @param stereoPanner The StereoPannerNode to modify
 * @param panValue Target pan value (-1 to +1)
 * @param audioContext AudioContext for timing
 * @param timeConstant Time constant for transition (default: 0.05 = ~150ms)
 */
export function applyStereoPanSmooth(
  stereoPanner: StereoPannerNode,
  panValue: number,
  audioContext: AudioContext,
  timeConstant: number = 0.05
): void {
  try {
    stereoPanner.pan.setTargetAtTime(
      panValue,
      audioContext.currentTime,
      timeConstant
    );
  } catch (err) {
    // Fallback: set value directly
    stereoPanner.pan.value = panValue;
  }
}
